import { useToast } from 'primevue/usetoast'
import { useI18n } from 'vue-i18n'
import { useBrandLimits } from '@/composables/useBrandLimits'

/** Used by SettingsBilling for grouped toasts with custom templates. */
export const APP_TOAST_GROUP = 'app'

export function useBrandLimitToast() {
  const toast = useToast()
  const { t } = useI18n()
  const { maxBrands, isAgencyFreeLimit } = useBrandLimits()

  function showBrandLimitToast() {
    if (isAgencyFreeLimit.value) {
      toast.add({
        group: APP_TOAST_GROUP,
        severity: 'warn',
        summary: t('add_brand_upgrade_required', { max: maxBrands.value }),
        life: 8000,
      })
      return
    }

    toast.add({
      group: APP_TOAST_GROUP,
      severity: 'warn',
      summary: t('add_brand_limit_reached', { max: maxBrands.value }),
      life: 5000,
    })
  }

  return { showBrandLimitToast }
}
